// Dashboards
export const NFT_DASHBOARD_PATH = '/nft-dashboard';
export const MEDICAL_DASHBOARD_PATH = '/medical-dashboard';

// Top-Level Paths
export const HOME_PATH = '/';
export const PROFESSIONAL_FISHER_PATH = '/professional-fisher';
export const ALL_PROFESSIONAL_FISHERS_PATH = '/all-professional-fishers';
export const REPORTS_PATH = '/reports';

// Fishing Operations
export const LICENSES_PATH = '/licenses';
export const LICENSES_RETURN_PATH = '/licenses-return';
export const FISHERS_PATH = '/fishers';
export const SESSIONS_PATH = '/sessions';
export const CATCHES_PATH = '/catches';
export const FISHING_INSPECTIONS_PATH = '/fishing-inspections';
export const IMPORT_PAPER_STATISTICS_PATH = '/paper-statistics';

// Fishing Management
export const INVENTORY_PATH = '/inventory';
export const NATURAL_BREEDING_PATH = '/natural-breeding';
export const STOCKING_PLAN_PATH = '/stocking-plan';
export const STOCKING_JOURNAL_PATH = '/stocking-journal';
export const STOCKING_YEARLY_SUMMARY_PATH = '/stocking-yearly-summary';
export const BREEDING_JOURNAL_PATH = '/breeding-journal';

// Fishing Habitat
export const FISH_MOVEMENT_PATH = '/fish-movement';
export const FISHING_OBSERVATIONS_PATH = '/fishing-observations';
export const DRAUGHTINESS_PATH = '/draughtiness';
export const WATER_QUALITY_PATH = '/water-quality';

// Hunting Operations
export const HUNTERS_PATH = '/hunters';
export const HUNTER_PATH = '/hunters/:id';
export const KILLS_PATH = '/kills';
export const HUNTING_INSPECTIONS_PATH = '/hunting-inspections';
export const HUNTING_LICENSES_PATH = '/hunting-licenses';

// Analytics
export const ANALYTICS_FISHING_OPERATIONS_PATH = '/analytics-fishing-operations';
export const ANALYTICS_FISHING_MANAGEMENT_PATH = '/analytics-fishing-management';
export const ANALYTICS_FISHING_HABITAT_PATH = '/analytics-fishing-habitat';
export const ANALYTICS_PROFESSIONAL_FISHERS_PATH = '/analytics-professional-fishers';
export const ANALYTICS_HUNTING_OPERATIONS_PATH = '/analytics-hunting-operations';
export const ANALYTICS_SUMMARY_PATH = '/analytics-summary';
export const ANALYTICS_BASIC_STATISTICS_PATH_PATH = '/analytics-basic-statistics';

// User Management
export const MEMBERS_PATH = '/members';
export const USER_DETAILS_PATH = '/user-details';
export const ROLES_PATH = '/roles';
export const MESSAGES_PATH = '/messages';
export const ORGANISATIONAL_UNITS_PATH = '/organisational-units';

// Master Data
export const WATERBODIES_PATH = '/waterbodies';
export const WATERBODY_REGULATIONS_PATH = '/waterbody-regulations';
export const GEOGRAPHIC_AREAS_PATH = '/geographical-areas';
export const LICENSE_TYPES_PATH = '/license-types';
export const FISH_TYPES_PATH = '/fishtypes';
export const NET_TYPES_PATH = '/net-type';
export const FISHING_FEES_PATH = '/fishing-fees';
export const HUNTING_FEES_PATH = '/hunting-fees';

// Settings
export const GENERAL_PATH = '/general';
export const WORKFLOWS_PATH = '/workflows';

// Admin Users
export const ADMIN_USERS_PATH = '/admin-users';

// Grouped Paths
export const groupedPaths = {
  TOP_LEVEL: {
    HOME_PATH,
    PROFESSIONAL_FISHER_PATH,
    ALL_PROFESSIONAL_FISHERS_PATH,
    REPORTS_PATH,
  },
  FISHING_OPERATIONS: {
    LICENSES_PATH,
    LICENSES_RETURN_PATH,
    FISHERS_PATH,
    SESSIONS_PATH,
    CATCHES_PATH,
    FISHING_INSPECTIONS_PATH,
    IMPORT_PAPER_STATISTICS_PATH,
  },
  FISHING_MANAGEMENT: {
    INVENTORY_PATH,
    NATURAL_BREEDING_PATH,
    STOCKING_PLAN_PATH,
    STOCKING_JOURNAL_PATH,
    STOCKING_YEARLY_SUMMARY_PATH,
    BREEDING_JOURNAL_PATH,
  },
  FISHING_HABITAT: {
    FISH_MOVEMENT_PATH,
    FISHING_OBSERVATIONS_PATH,
    DRAUGHTINESS_PATH,
    WATER_QUALITY_PATH,
  },
  HUNTING_OPERATIONS: {
    HUNTERS_PATH,
    KILLS_PATH,
    HUNTING_INSPECTIONS_PATH,
    HUNTING_LICENSES_PATH,
  },
  ANALYTICS: {
    ANALYTICS_FISHING_OPERATIONS_PATH,
    ANALYTICS_FISHING_MANAGEMENT_PATH,
    ANALYTICS_FISHING_HABITAT_PATH,
    ANALYTICS_PROFESSIONAL_FISHERS_PATH,
    ANALYTICS_HUNTING_OPERATIONS_PATH,
    ANALYTICS_SUMMARY_PATH,
    ANALYTICS_BASIC_STATISTICS_PATH_PATH,
  },
  USER_MANAGEMENT: {
    MEMBERS_PATH,
    ROLES_PATH,
    ORGANISATIONAL_UNITS_PATH,
    MESSAGES_PATH,
  },
  MASTER_DATA: {
    WATERBODIES_PATH,
    WATERBODY_REGULATIONS_PATH,
    GEOGRAPHIC_AREAS_PATH,
    LICENSE_TYPES_PATH,
    FISH_TYPES_PATH,
    NET_TYPES_PATH,
    FISHING_FEES_PATH,
    HUNTING_FEES_PATH,
  },
  SETTINGS: {
    GENERAL_PATH,
    WORKFLOWS_PATH,
  },
};

export const ALL_PATHS = [
  HOME_PATH,
  ...Object.values(groupedPaths.FISHING_OPERATIONS),
  ...Object.values(groupedPaths.FISHING_MANAGEMENT),
  ...Object.values(groupedPaths.FISHING_HABITAT),
  PROFESSIONAL_FISHER_PATH,
  ALL_PROFESSIONAL_FISHERS_PATH,
  ...Object.values(groupedPaths.HUNTING_OPERATIONS),
  ...Object.values(groupedPaths.ANALYTICS),
  ...Object.values(groupedPaths.USER_MANAGEMENT),
  ...Object.values(groupedPaths.MASTER_DATA),
  REPORTS_PATH,
  ...Object.values(groupedPaths.SETTINGS),
];
